
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import {
  FormConfig,
  QuestionnaireItem,
  WizardStep,
} from "../../../../interfaces/dynamicForms/Forms";
import LeaveConfirmationModal from "../../../ui/ConfirmationModals/LeaveConfirmationModal";
import { FormInput } from "./FormInput";
import { isQuestionVisible, SelectOption } from "./utils";
import "./FormInput.css";

type DynamicOptionsMap = Record<string, SelectOption[]>;

interface StepPanelProps {
  step: WizardStep;
  currentStepIndex: number;
  totalSteps: number;
  formData: Record<string, any>;
  errors: Record<string, string>;
  onChange: (questionId: string) => (val: any) => void;
  onNext: () => void;
  onPrev: () => void;
  dynamicOptions: DynamicOptionsMap;
  isSubmitting: boolean;
  clearForm: () => void;
  formConfig: FormConfig;
  participantId?: string;
  autoPopulateData?: Record<string, any>;
}

export const StepPanel: React.FC<StepPanelProps> = ({
  step,
  currentStepIndex,
  totalSteps,
  formData,
  errors,
  onChange,
  onNext,
  onPrev,
  dynamicOptions,
  isSubmitting,
  clearForm,
  formConfig,
  participantId,
  autoPopulateData,
}) => {
  const visibleQuestions = step.questions.filter((q) =>
    isQuestionVisible(q, formData)
  );
  const [showClearConfirm, setShowClearConfirm] = useState(false);

  async function openDialog() {
    setShowClearConfirm(true);
  }

  async function onCancel() {
    setShowClearConfirm(false);
  }
  async function onClearForm() {
    clearForm();
    setShowClearConfirm(false);
  }
  return (
    <>
      <div className="top top_bar_flx border_tittle">
        <div className="top_bar_tittle">
          <h2>{step.label}</h2>
        </div>
        <div className="step_form_count">
          <p>
            <span>Step {currentStepIndex + 1}</span> / {totalSteps}
          </p>
        </div>
      </div>

      <>
        {visibleQuestions.map((q) => {
          const val = formData[q.id];
          const err = errors[q.id] || "";

          return (
            <div className="labelBlock">
              <div key={q.id} className="custom_input_flled">
                {q.type !== "checkbox" && (
                  <label>
                    {q.label}
                    {q.validation?.required && (
                      <span className="text-red-500 ml-1">*</span>
                    )}
                  </label>
                )}
                <FormInput
                  q={q}
                  value={val}
                  onChange={onChange(q.id)}
                  dynamicOptions={dynamicOptions}
                  formConfig={formConfig}
                  participantId={participantId}
                  autoPopulateData={autoPopulateData}
                />

                {err && <div className="text-red-500 text-sm mt-1">{err}</div>}
              </div>
            </div>
          );
        })}
      </>

      {/* Navigation Buttons */}
      <div className="form_btn_flx">
        {currentStepIndex > 0 && (
          <Button
            type="button"
            variant="secondary"
            onClick={onPrev}
            disabled={isSubmitting}
          >
            Back
          </Button>
        )}
        <Button onClick={openDialog}>Clear Form</Button>

        <Button
          type="button"
          variant="primary"
          onClick={onNext}
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Submitting..."
            : currentStepIndex < totalSteps - 1
            ? "Next Step"
            : "Complete"}
        </Button>
      </div>

      {showClearConfirm && (
        <LeaveConfirmationModal
          isLoading={false}
          onCancel={onCancel}
          onConfirm={onClearForm}
        >
          Are you sure you want to clear the form?
        </LeaveConfirmationModal>
      )}
    </>
  );
};
